import ScalarWrappingText_default from "./ScalarWrappingText.vue.js";
export { ScalarWrappingText_default as ScalarWrappingText };
